import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { onMounted, ref, type PropType } from 'vue';
import VueSlider from 'vue-slider-component/dist/vue-slider-component.umd.min.js';


export const OtSliderColorVariants = {
  default: 'default',
  primary: 'primary',
  secondary: 'secondary',
  success: 'success',
  error: 'error',
} as const;
export type OtSliderColorVariant = (typeof OtSliderColorVariants)[keyof typeof OtSliderColorVariants];

export default /*#__PURE__*/_defineComponent({
  __name: 'XSlider',
  props: {
  fitTooltipMaxValue: { type: Boolean, default: false },
  colorVariant: { type: String as PropType<OtSliderColorVariant>, default: 'default' },
},
  setup(__props) {



const sliderElem = ref();

onMounted(() => {
  /**
   * https://github.com/NightCatSama/vue-slider-component/issues/263
   */
  sliderElem.value?.$el?.getElementsByClassName('vue-slider-dot')[0]?.setAttribute('tabindex', '-1');
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueSlider), _mergeProps({
    ref_key: "sliderElem",
    ref: sliderElem,
    class: "x-slider"
  }, _ctx.$attrs, {
    class: [`x-slider--${__props.colorVariant}`, { 'x-slider--fit-tooltip-max': __props.fitTooltipMaxValue }]
  }), null, 16, ["class"]))
}
}

})